import React from "react";
import { Role } from "@blisspointmedia/bpm-types/dist/Users";
import { MigrationPage } from "../MigrationPage";

export const roleMap = {
  [Role.ADMIN]: "Admin",
  [Role.INTERNAL]: "User",
  [Role.EXTERNAL]: "User",
};

const UserAdmin = (): JSX.Element => <MigrationPage title="User Admin" pageType="User Admin" />;

export default UserAdmin;
